import React, { useEffect, useState, useRef } from 'react';
import TransactionTypeSetting from '../../../API/APIServices/TransactionTypeSetting';
import BillSeriesMaster from '../../../API/APIServices/BillSeriesMaster';
import MasterListReportFormat2 from '../../Utilities/ReportSetting/MasterListReportFormat2';
import ConfirmDeletionWithUserInput from '../../Props/ConfirmDeletionWithUserInput';
import MastersModalBox from '../../Props/MastersModalBox';
import CustomizeDeleteService from '../../../API/APIServices/CustomizeDeleteService';


function TransactionCustomizeDelete({ setLoading }) {

    const [transactionTypeSettingList, setTransactionTypeSettingList] = useState([]);
    const [billSeriesList, setBillSeriesList] = useState([]);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [confirmDeleteOpenAll, setConfirmDeleteOpenAll] = useState(false);

    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [transactionTypeSettingId, setTransactionTypeSettingId] = useState(0);
    const [billSeriesId, setBillSeriesId] = useState(0);
    const [transactionList, setTransactionList] = useState([]);
    const [showReport, setShowReport] = useState(false);
    const [criteria, setCriteria] = useState(1);
    const [isBillSeriesShow, setIsBillSeriesShow] = useState(false);

    const childRef = useRef();
    const dropDownRef = useRef();
    const dropDownRef1 = useRef();

    useEffect(() => {

        function handleClickOutside(event) {


            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setIsBillSeriesShow(false);
            }
        }



        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);


    useEffect(() => {
        console.log("dateFrom", dateFrom)
    }, [dateFrom])

    async function fetchData() {

        setLoading(true);
        try {
            const filter = {

                "filter": [
                    {
                        "fieldName": "typeId",
                        "operatorName": "NotEqual",
                        "compareValue": 226
                    }
                ],
                "order": [
                    {
                        "propertyName": "string",
                        "ascending": true
                    }
                ],
                "pageNumber": 0,
                "pageSize": 500
            };

            var data = await TransactionTypeSetting.GetAllTransactionTypeMaster();

            if (data) {
                setTransactionTypeSettingList(data);
            } else {
                setTransactionTypeSettingList([]);
            }

        } catch (error) {
            console.log("Error on fetching transaction type", error);
        }

        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchBillSeriesMaster(id) {

        setLoading(true);

        try {

            const filter = [
                {
                    "fieldName": "parentGrpMasterId",
                    "operatorName": "equal",
                    "compareValue": id
                }
            ];

            var data = await BillSeriesMaster.getBillSeriesMasterFiltered(filter);

            if (data) {

                const list = data.map(item => {
                    item.isSelected = false;
                    return item;
                })

                setBillSeriesList(list);
            } else {
                setBillSeriesList([]);
            }

        } catch (error) {
            console.log("Error on fetching  bill series master", error);
        }

        setLoading(false);
    }

    function handleTransactionTypeChange(id) {

        setTransactionTypeSettingId(id);

        if (id == 0) {
            setBillSeriesList([]);
            return;
        }

        fetchBillSeriesMaster(id);
    }

    function addOrders(id_list) {
        console.log("add order called...", id_list);

        setTransactionList(id_list);
        // setConfirmDeleteOpen(true);
    }

    async function handleDelete() {

        setConfirmDeleteOpen(false);

        setLoading(true);

        const transSeriesList = billSeriesList.filter(item => item.isSelected).map(item => Number(item.id));

        const data = {
            "trans": [
                {
                    "transId": transactionTypeSettingId,
                    "transSeries": transSeriesList
                }
            ],
            "custDelDeletionCriteria": criteria
        }


        console.log("data", data);

        try {
            const response = await CustomizeDeleteService.DeleteTransactionsAsync(data);
            
            if (response.data.isSuccess) {
                setShowReport(false);
                alert("Transaction Deleted Successfully!");
            } else {
                console.log("Error in Transaction Customize Delete!", response.data.errorMessages);
                alert("Failed to delete Transaction Customize Delete!");
            }
        } catch (error) {
            console.log("Error in Transaction Customize Delete!", error);
            alert("Failed to delete Transaction Customize Delete!");
        }

        setLoading(false);
    }

    function handleShowReport() {

        setTransactionList([]);
        setShowReport(false);

        setTimeout(() => {

            setShowReport(true);
        }, 300);
    }

    const DeletionCriteria = [

        { key: "AllTransaction", name: "All Transaction", value: 1 },
        { key: "FullPaidAvoidBankTransction", name: "Full Paid Avoid Bank Transaction", value: 2 },
        { key: "FullPaid", name: "Full Paid", value: 3 },
        { key: "AllTransaction_n_DelItem", name: "All Transaction_n_DelItem", value: 4 },
        { key: "FullPaidAvoidBankTransction_n_DelItem", name: "Full Paid Avoid Bank Transction_n_DelItem", value: 5 },
        { key: "FullPaid_n_DelItem", name: "Full Paid_n_DelItem", value: 6 },
    ]

    // public enum EnmCustDelTrans
    // {
    //     AllTransaction = 1,
    //     FullPaidAvoidBankTransction = 2,
    //     FullPaid = 3,

    //     AllTransaction_n_DelItem = 4,
    //     FullPaidAvoidBankTransction_n_DelItem = 5,
    //     FullPaid_n_DelItem = 6
    // }

    function toggleBillSeriesShow() {

        setIsBillSeriesShow(!isBillSeriesShow);
    }

    function handleBillSeriesSelect(e, index) {

        const { value, checked } = e.target;

        const tempBillSeriesList = [...billSeriesList];

        tempBillSeriesList[index].isSelected = checked;
        setBillSeriesList(tempBillSeriesList);
    }

    async function handleDeleteAllTransactionAccountItemAndTheirGroups() {

        setConfirmDeleteOpenAll(false);

        setLoading(true);

        const data = {};

        try {
            const response = await CustomizeDeleteService.ResetTransItemsAccountsAsync(data);
            
            if (response.data.isSuccess) {
                setShowReport(false);
                alert("All Transaction, Account, Account Group, Item, Item Group Deleted Successfully!");
            } else {
                console.log("Error in ResetTransItemsAccountsAsync Customize Delete!", response.data.errorMessages);
                alert("Failed to delete all Transaction, Account, Account Group, Item, Item Group Customize Delete!");
            }
        } catch (error) {
            console.log("Error in ResetTransItemsAccountsAsync Customize Delete!", error);
            alert("Failed to delete all Transaction, Account, Account Group, Item, Item Group Customize Delete!");
        }

        setLoading(false);
    }

    return (
        <div className="padding-20">

            <div className="company_info-text-im relative">
                Transaction Deletion
                <button onClick={() => setConfirmDeleteOpen(!confirmDeleteOpen)} className="product-price-account-wise-delete-button customize-delete-button">Delete</button>

            </div>

            <div className="HeadContentInputBpx" style={{ alignItems: "center" }}>



                {/* <div className="input-box-m11">
                    <input value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} className="modify_im_input mode_limit mode_category" type="date" required />
                    <label class="ItemMasterLabelFix">Date From</label>
                </div>

                <div className="input-box-m11">
                    <input value={dateTo} onChange={(e) => setDateTo(e.target.value)} className="modify_im_input mode_limit mode_category" type="date" required />
                    <label class="ItemMasterLabelFix">Date To</label>
                </div> */}

                <div className="input-box-m11">
                    <select value={transactionTypeSettingId} onChange={(e) => handleTransactionTypeChange(Number(e.target.value))} className="modify_im_input mode_category" type="text" required>
                        <option value={0}>--Select--</option>

                        {transactionTypeSettingList.map((item, index) => (
                            <option key={index} value={item.id}>{item.masterName}</option>
                        ))}

                    </select>
                    <label class="ItemMasterLabelFix" >Transaction</label>

                </div>

                <div className="input-box-m11">

                    <div ref={dropDownRef} style={{ border: "1px solid #CCCCCC", borderRadius: "4px" }} className='customize-delete-custome-select-option relative'>

                        <div onClick={toggleBillSeriesShow} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", cursor:"pointe" }}>
                            <div>Select Bill Series</div>
                            <i class={`fa-solid fa-circle-chevron-down arrow ${isBillSeriesShow ? "rotated" : ""}`}></i>
                        </div>

                        {isBillSeriesShow && (
                            <div className='customize-delete-custome-select-box'>
                                {billSeriesList.map((item, index) => (
                                    <div className='customize-delete-custome-select-option' key={index}>
                                        <div className='customize-delete-custome-select-option-div'>{item.billSeriesName}</div>
                                        <input className='customize-delete-custome-select-option-input' type="checkbox" onChange={(e) => handleBillSeriesSelect(e, index)} checked={item.isSelected} value={item.id} />
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                </div>

                <div className="input-box-m11">
                    <select value={criteria} onChange={(e) => setCriteria(Number(e.target.value))} className="modify_im_input mode_category" type="text" required>

                        {DeletionCriteria.map((item, index) => (
                            <option key={index} value={item.value}>{item.name}</option>
                        ))}

                    </select>
                    <label class="ItemMasterLabelFix" >Delete Criteria</label>

                </div>

                {/* <div className="input-box-m11">
                    <select value={billSeriesId} onChange={(e) => setBillSeriesId(Number(e.target.value))} className="modify_im_input mode_category" type="text" required>
                        <option value={0}>--Select--</option>

                        {billSeriesList.map((item, index) => (
                            <option key={index} value={item.id}>{item.billSeriesName}</option>
                        ))}

                    </select>
                    <label class="ItemMasterLabelFix" >Bill Series</label>

                </div> */}

                {/* <button className='tab active' onClick={handleShowReport}>Show Transaction</button> */}

            </div>

            <div className="company_info-text-im relative" style={{ marginTop: "20px" }}>
                Delete All Transaction, Account, Account Group, Item And Item Group

            </div>

            <div className="HeadContentInputBpx" style={{flexDirection: "column", gap: "10px"}}>

                <div style={{ color: "red", fontWeight: "bold", fontSize: "30px" }}>Click Below Button To Delete All Transaction, Account, Account Group, Item, Item Group</div>

                <button onClick={() => setConfirmDeleteOpenAll(!confirmDeleteOpenAll)} className="product-price-account-wise-delete-button">Delete</button>

            </div>



            {showReport && (

                <div style={{ maxWidth: "90vw", overflow: "auto" }}>
                    <MasterListReportFormat2
                        // ref={childRef}
                        showNav={false}
                        // dateFrom={dateFrom}
                        // dateTo={dateTo}
                        // seriesId={billSeriesId}
                        // seriesIds={billSeriesList.filter(item => item.isSelected).map(item => item.id)}
                        addOrders={addOrders}
                        id={transactionTypeSettingId}
                        // handleSetSelectedId={handleSetSelectedId}
                        hideAddButton={true}
                    />
                </div>

            )}


            {confirmDeleteOpen && <ConfirmDeletionWithUserInput
                HeadingTop="Are you sure you want to delete!"
                closeButtonClick={() => { setConfirmDeleteOpen(false) }}
                onYesClick={handleDelete}
            />}

            {confirmDeleteOpenAll && <ConfirmDeletionWithUserInput
                HeadingTop="Are you sure you want to delete all transaction, account, account group, item and item group!"
                closeButtonClick={() => { setConfirmDeleteOpenAll(false) }}
                onYesClick={handleDeleteAllTransactionAccountItemAndTheirGroups}
            />}

        </div>
    );
}

export default TransactionCustomizeDelete;